import { useState, useEffect,useRef } from "react";
import { NavLink } from "react-router-dom";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import headerLogo from "../styles/webroot/images/header_logo.png"
import bellIcon from '../styles/webroot/images/bell_icon.png';
import {getNotificationCount,getNotificationList,readNotificationHistory} from '@src/store/slices/common';
import NotificationDropdown from './NotificationDropdown';
import { STATUS_CODES } from "@src/config/constant";


const Navigation = () => {
    // const [role, setRole] = useState("");
    // eslint-disable-next-line
    const [isMount, setIsMount] = useState(false);
    // eslint-disable-next-line
    const [redirect, setRedirect] = useState(false);
    const [name, setName] = useState("");
    const [id, setID] = useState("");
    const [showNotiCount, setShowNotiCount] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const [notifications, setNotifications] = useState<any>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const navigate = useNavigate();
    const dropdownRef = useRef<HTMLDivElement | null>(null);
    const bellIconRef = useRef<HTMLAnchorElement>(null);

    useEffect(() => {
        setIsMount(true);
        let result = secureStorage.getItem("authAgentUserInfo");

        if (!result) {
            setRedirect(true)
        } else {
            let userInfo = result.user_data;
            setName((userInfo && userInfo.name) || '');
            setID((userInfo && userInfo.id) || '')
            // setRole((userInfo && userInfo.assigned_role_name) || '');

        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                bellIconRef.current &&
                !bellIconRef.current.contains(event.target as Node)
            ) {
                setShowNotificationDropdown(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const fetchNotifications = async (page:number) => {
        try {
          const response:any = await getNotificationList({ page_number: page });
          const { datalist, nextpage } = response.data;
          setNotifications((prev:any) => [...prev, ...datalist]);
          setHasMore(nextpage);
        } catch (error) {}
      };
    
    useEffect(() => {
        const fetchNotificationCount = async () => {
            try {
                const res: any = await getNotificationCount();
                const count = res.data.count || 0;
                setNotificationCount(count);
                setShowNotiCount(count > 0);
                fetchNotifications(pageNumber);
            } catch (error) {}
        };
    
        fetchNotificationCount();
        // eslint-disable-next-line
    }, [])

    const handleNotificationClick = async (id: number, noti_type:string,leadHashId:string,is_read:string) => {
        if(is_read === "0"){
            const res: any = await readNotificationHistory({id : id});
            if(res.status === STATUS_CODES['success']){
                setNotifications((prevNotifications:any) =>
                    prevNotifications.map((notification:any) =>
                        notification.id === id
                        ? { ...notification, is_read: 1 }
                        : notification
                    )
                );
                setNotificationCount((prevCount: number) => {
                    const newCount = prevCount - 1;
                    setShowNotiCount(newCount > 0);
                    return newCount;
                });
            }
        }
        if(noti_type === "document_resubmission"){
            setShowNotificationDropdown(false);
            navigate(`/create-insurance-policy/${leadHashId}`);
        }
    };

    const loadMoreNotification = async() => {
        setPageNumber((prevPageNumber) => {
            const newPageNumber = prevPageNumber + 1;
            fetchNotifications(newPageNumber);
            return newPageNumber;
        });
    }

    const logOutUser = async () => {
        let result = secureStorage.getItem("authAgentUserInfo")
        if (result) {
            secureStorage.removeItem("authAgentUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(() => { navigate('/login'); }, 100)
        }
    };

    //Re direct home page
    const redirectToDashboard = () => {
        navigate('/dashboard');
    };

    // for name and ID fetch updated
    useEffect(() => {
    const updateUserInfo = () => {
        let result = secureStorage.getItem("authAgentUserInfo");
        if (result?.user_data) {
            setName(result.user_data.name || "");
            setID(result.user_data.id || "");
        }
    };

    window.addEventListener("auth-info-updated", updateUserInfo);

    return () => {
        window.removeEventListener("auth-info-updated", updateUserInfo);
    };
}, []);


    return (
        <div className="container-fluid nav-web">
            <div className="header-main">
                <div className="logo cursor-point">
                    <img src={headerLogo} className="" alt="insurance-logo" onClick={redirectToDashboard} />
                </div>
                <div className="right-panel-naviganion menupanel">
                    <div className="nav">
                        <ul>
                            {
                                // HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['dashboard_page'], accessType: 'isVisible'}) ?
                                <li><NavLink to="/dashboard">Dashboard</NavLink></li>
                                // : ''
                            }
                            {
                                // HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['listing_page'], accessType: 'isVisible'}) ?
                                <li><NavLink to="/insurance-list">Manage Panel</NavLink></li>
                                // : ''
                            }
                            <li>
                                <NavLink className="p-relative" to="#" onClick={() => setShowNotificationDropdown((prev) => !prev)} ref={bellIconRef}>
                                    <img src={bellIcon} alt=""/>
                                    {
                                        showNotiCount && 
                                        <span className="notification-bubble">{notificationCount}</span>
                                    }
                                </NavLink>
                                {showNotificationDropdown && (
                                    <div ref={dropdownRef}>
                                        <NotificationDropdown
                                            notifications={notifications}
                                            onClose={() => setShowNotificationDropdown(false)}
                                            handleNotificationClick={handleNotificationClick}
                                            fetchMoreNotifications={loadMoreNotification}
                                            hasMore={hasMore}
                                        />
                                    </div>
                                )}
                            </li>
                        </ul>
                    </div>
                    {/* <div className="notification-btn">
                        <Notification />

                    </div> */}

                    <div className="user-detail ">
                        <ul>

                            <li className="dropdownmenu"><NavLink to="#">
                                <span className="userarc">
                                    {name[0]?.toUpperCase()}
                                </span>
                                <div className="username">
                                    <span>{name}</span>
                                    <span className="user-degintion">ID: {id}</span>
                                </div>
                            </NavLink>
                                <ul className="submenu">
                                    <li><NavLink to="my-profile" >My Profile</NavLink> </li>
                                    <li><NavLink to="#" onClick={logOutUser}>Logout</NavLink> </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                    {/* <div className="language">
                        <ul>
                            <li className="dropdownmenu">
                                <NavLink to="#">
                                    ENG
                                </NavLink>
                                <ul className="submenu">
                                    <li><NavLink to="#">Eng</NavLink> </li>
                                </ul>
                            </li>

                        </ul>
                    </div> */}
                </div>

            </div>

        </div >
    );
}

export default Navigation;